<template>
  <div id="homepage">
    <!-- <Header></Header> -->
    <!-- <Solid></Solid> -->
    <div class="leftpadding">
      <div>
        <!-- <Cardtitle msg="基本信息"></Cardtitle> -->
        <div>
          <div class="cardbox">
            <a-row class="cardContainer">
              <a-col>
                <Cardinfo @loginOut="loginOut"></Cardinfo>
              </a-col>
              <a-col
                class="btnBox"
              >
                <div class="flex">
                  <a-button
                    @click="gostuscore"
                    shape="round"
                    style="background: #fca046"
                    class="btnsize"
                  >
                    <img
                      src="../../assets/sou-suo.png"
                      class="sou-btn"
                    />
                    <span style="color: #ffffff">查看受训人员成绩</span>
                  </a-button>
                  <a-button
                    class="btnsize"
                    type="danger"
                    @click="toPublish"
                    shape="round"
                    v-if="this.hasTeacherVersion"
                    >发布公告</a-button
                  >
                  <a-button
                    class="btnsize"
                    shape="round"
                    @click="centerDialogVisible = true"
                    type="primary"
                    round
                    >预约训练</a-button
                  >
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- </a-col> -->
        <!-- </a-row> -->
      </div>
      <!-- 训练记录 -->
      <div class="tableContainer">
        <div class="titleText recordBox">
          <img src="../../assets/record.png" class="titlePic" />
          <span class="tit">演练记录</span>
          <router-link
            class="moreRecord"
            :to="{
              path: '/moreRecord',
            }"
            >更多></router-link>
        </div>
        <a-row style="padding: 1vw">
          <a-col>
            <div class="tablebox">
              <a-table
                :locale="{ emptyText }"
                :columns="columns"
                :data-source="tableData"
                :pagination="false"
                rowKey="index"
                :scroll="{ x: true }"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="seedetails(record)">查看详情</a>
                </span>
              </a-table>
            </div>
          </a-col>
        </a-row>
        <!-- 演练配置 -->
        <div class="titleText" v-if="this.hasTeacherVersion">
          <img src="../../assets/peizhi.png" class="titlePic" />
          <span class="tit">演练配置</span>
        </div>
        <div class="configBox" v-if="this.hasTeacherVersion">
          <div class="itemContainer">
            <div class="configItem" @click="toYhaDigitalCodeList">
              <img src="../../assets/erweima.png" class="configImg" />
              <div>受训人员</div>
              <div>二维码配置</div>
            </div>
            <div class="configItem" @click="toDepartmentsetting">
              <img src="../../assets/xuexi.png" class="configImg" />
              <div>受训人员</div>
              <div>部门配置</div>
            </div>
            <div class="configItem" @click="toYhaFiledControlList">
              <img src="../../assets/renyuan.png" class="configImg" />
              <div>受训人员</div>
              <div>信息配置</div>
            </div>
          </div>
          <div class="itemContainer">
            <div class="configItem" @click="toYhaTheoryList">
              <img src="../../assets/kaoti.png" class="configImg" />
              <div>理论学习</div>
              <div>考题配置</div>
            </div>
            <div class="configItem" @click="toYhaVideoList">
              <img src="../../assets/shipin.png" class="configImg" />
              <div>理论学习</div>
              <div>视频配置</div>
            </div>
            <div class="configItem" @click="toYhaFormworkList">
              <img src="../../assets/zhenshu.png" class="configImg" />
              <div>培训证书</div>
              <div>配置</div>
            </div>
          </div>
        </div>
        <!-- 演练照片 -->
        <Picture :picture="picture"></Picture>
        <!-- 演练照片 -->
        <div>
          <div class="titleText">
            <img src="../../assets/baogaozhuanqu.png" class="titlePic" />
            <span class="tit">报告专区</span>
          </div>
          <div class="reportContainer">
            <div
              v-for="item in this.reportList"
              class="reportItem"
              :key="item.id"
              @click="reportDetail(item)"
            >
              <img src="../../assets/yanlianweb.png" class="reportImg" />
              <div class="reportDate">{{ item.actBatchCode }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约弹框 -->
    <a-modal
      title="预约下次训练"
      @cancel="closeappoint"
      :maskClosable="true"
      :visible.sync="centerDialogVisible"
      center
    >
      <!-- width="30vw" -->
      <a-row class="flex inputbar">
        <a-col class="inputtext">
          <span>联系方式：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input v-model="bookinfo.iphone" placeholder="请输入您的联系方式" />
        </a-col>
      </a-row>
      <a-row class="flex inputbar">
        <a-col class="inputtext">
          <span>联系人：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input v-model="bookinfo.linkMan" placeholder="请输入联系人姓名" />
        </a-col>
      </a-row>

      <a-row class="flex inputbar">
        <a-col class="inputtext">
          <span>单位全称：</span>
        </a-col>
        <a-col :span="15" class="inputs">
          <a-input type="text" v-model="bookinfo.universityName" />
          <!-- {{  }} -->
        </a-col>
      </a-row>
      <!-- <a-row class="flex inputbar">
        <a-col :span="6" class="inputtext">
          <span>部门：</span>
        </a-col> -->
      <!-- <a-col :span="15" class="inputs">
          <a-select
            class="departselect"
            v-model="bookinfo.departmentName"
            style="width: 100%"
            @change="handdepartChange"
          >
            <a-select-option
              class="depart"
              v-for="item in departlist"
              :key="item.id"
              :value="item.departmentName"
              >{{ item.departmentName }}</a-select-option
            >
          </a-select>
        </a-col> -->
      <!-- </a-row> -->
      <a-row class="flex inputbar">
        <a-col class="inputtext">
          <span>培训时间：</span>
        </a-col>
        <a-col
          :xs="{ span: 15, offset: 0 }"
          :md="{ span: 15, offset: 0 }"
          class="inputs"
        >
          <!-- locale -->
          <!-- <a-locale-provider :locale="locale"> -->
          <a-date-picker
            :allowClear="false"
            :locale="locale"
            width="100%"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="traintime"
            :disabled-date="disabledDate"
            :disabled-time="disabledDateTime"
            placeholder="选择日期"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
          <!-- </a-locale-provider> -->
        </a-col>
      </a-row>
      <span slot="footer" class="dialog-footer">
        <a-button round class="booksurebtn" type="primary" @click="sureappoint"
          >确 认 预 约</a-button
        >
      </span>
    </a-modal>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Search from "@/components/Search/Search";
import Cardtitle from "@/components/Cardtitle/Cardtitle";
import Cardinfo from "@/components/Cardinfo/Cardinfotwo";
import Solid from "@/components/Solid/Solid";
import moment from "moment";
import Axios from "@/Axios";
import infoAction from "@/utils";
import Picture from "@/components/Picture/Picture";
// import zhCN from '@/ant-design-vue/lib/locale-provider/zh_CN';
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "Homepage",
  components: {
    Header,
    Search,
    Cardtitle,
    Cardinfo,
    Solid,
    Picture,
  },
  data() {
    return {
      emptyText: "暂无数据",
      picture: [],
      reportList: [], // 报告列表
      hasTeacherVersion: "",
      locale: {
        // lang:{
        //   timeSelect:'选择时间',
        //   dateSelect:'选择日期',
        //   dateFormat: "M/D/YYYY",
        //   dateTimeFormat: "M/D/YYYY HH:mm:ss",
        //   now:'现在时间 ',
        //   ok:'确认'
        // }
        lang: {
          placeholder: "请选择日期",
          rangePlaceholder: ["Start date", "End date"],
          today: "今天",
          now: "现在时间",
          backToToday: "Back to today",
          ok: "Ok",
          clear: "Clear",
          month: "Month",
          year: "Year",
          timeSelect: "选择时间",
          dateSelect: "选择日期",
          monthSelect: "Choose a month",
          yearSelect: "Choose a year",
          decadeSelect: "Choose a decade",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          monthBeforeYear: true,
          previousMonth: "Previous month (PageUp)",
          nextMonth: "Next month (PageDown)",
          previousYear: "Last year (Control + left)",
          nextYear: "Next year (Control + right)",
          previousDecade: "Last decade",
          nextDecade: "Next decade",
          previousCentury: "Last century",
          nextCentury: "Next century",
        },
        timePickerLocale: {
          placeholder: "Select time",
        },
      },
      traintime: "",
      universityname: infoAction.getinfo("universityId_dictText", false),
      input: "",
      url: {
        appoint: "/subscribe/yhaSubscribe/add",
        departlist: "/departments/yhaDepartments/list",
        university: "/university/yhaUniversity/queryById",
        trainlist: "/subscribe/yhaSubscribe/list",
        trainarrange: "/repcomposer/repComposer/report",
        alluniverrecord: "/repcomposer/repComposer/newReport",
        yhaPicture: "/picture/yhaPicture/list",
        reportUrl: "/pdframework/yhaPdfFramework/list",
      },
      // 测试
      pagination: {
        pageNo: 1,
        pageSize: 5, // 默认每页显示数量
        // showSizeChanger: true, // 显示可改变每页数量
        // pageSizeOptions: ["5", "10", "20", "50", "100"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        // onShowSizeChange: this.onShowSizeChange, // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
      },
      bookinfo: {
        iphone: "",
        orderDate: "",
        universityName: "",
        linkMan: "",
        // departmentName: "",
      },
      departlist: [],
      centerDialogVisible: false,
      columns: [
        {
          dataIndex: "traintime",
          title: "训练时间",
          key: "traintime",
          align: "center",
          
        },
        {
          title: "活动编码",
          dataIndex: "activeCode",
          key: "activeCode",
          align: "center",
        },
        {
          title: "参与部门",
          dataIndex: "traindepartment",
          key: "traindepartment",
          align: "center",
        },
        {
          title: "参与人数",
          dataIndex: "peoplenum",
          key: "peoplenum",
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
        },
      ],
      tableData: [],
      tableheaderstyle: {
        backgroundColor: "#A6cefd",
      },
      universityId: infoAction.getinfo("teacher_info").universityId,
    };
  },
  created() {
    // this.hasTeacherVersion = this.$store.getters.getTeacherVersion
    this.hasTeacherVersion = infoAction.getinfo("TeacherVersion");
  },
  mounted() {
    // 获取单位信息
    this.getunivesity();
    // 获取训练安排
    this.alluniverrecord();
    // 测试需要的预约列表
    // this.gettrainlist();
    this.getPicture();
    this.getReportList();
  },
  methods: {
    // 退出登录
    loginOut() {
      localStorage.clear()
      this.$router.push('/')
    },
    getReportList() {
      Axios.get(this.url.reportUrl, {
        params: {
          pageNo: 1,
          pageSize: 3,
          universityId: infoAction.getinfo("teacher_info").universityId
        },
      }).then((res) => {
        this.reportList = res.data.result.records;
      });
    },
    reportDetail(item) {
      console.log(item);
      this.$router.push({
        path: "/reportDetail",
        query: { remarkUrl: item.conclusionRemarkUrl },
      });
    },
    getPicture() {
      Axios.get(this.url.yhaPicture, {
        params: {
          universityId: infoAction.getinfo("teacher_info").universityId,
          pageNo: 1,
          pageSize: 10,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.picture = res.data.result.records;
          this.picture.map((item) => {
            const picUrl = window.network["imgUrl"] + "/";
            item.pictureUrl = picUrl + item.picUrl;
          });
        }
      });
    },
    // 演练配置跳转
    toDepartmentsetting() {
      window.location.href =
        "/admin/schoolAnddepartment/departmentsetting" +
        "?" +
        "受训人员部门配置";
    },
    toYhaFiledControlList() {
      window.location.href =
        "/admin/fieldcontroller/YhaFiledControlList" + "?" + "受训人员信息配置";
    },
    toYhaDigitalCodeList() {
      window.location.href =
        "/admin/schoolAnddepartment/YhaDigitalCodeList" +
        "?" +
        "受训人员二维码配置";
    },
    toYhaVideoList() {
      window.location.href =
        "/admin/teacherVideo/TeacherVideoList" + "?" + "理论学习视频配置";     
    },
    toYhaTheoryList() {
      window.location.href =
        "/admin/teacherTheory/TeacherTheoryList" + "?" + "理论学习考题配置";
    },
    toYhaFormworkList() {
      window.location.href =
        "/admin/frameworksettings/YhaFormworkList" + "?" + "培训证书配置";
    },
    toPublish() {
      window.location.href = "/admin/notice/YhaNoticeList" + "?" + "发布公告";
    },
    moment,
    handleviewdetails(index, data) {},
    // 查看受训人员成绩
    gostuscore() {
      this.$router.push("/searchresult");
    },
    // alluniverrecord
    // 获取训练记录
    gettrainarrange() {
      var data = [];
      Axios.get(this.url.trainarrange, {
        params: {
          // activeCode: infoAction.getinfo("activeCode"),
          activeCode: 0,
          departmentId: 0,
          linkName: infoAction.getinfo("teacher_info").name,
          universityId: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          var allarr = [];
          console.log(records);
          records.map((item, index) => {
            console.log(item.originalData);
            var arr;
            if (item.step == "1" && JSON.parse(item.originalData).length) {
              console.log(item.originalData);
              arr = JSON.parse(item.originalData);
              for (var i = 0; i < arr.length; i++) {
                var obj = {};
                obj.id = item.id;
                obj.departmentId = item.departmentId;
                obj.universityId = item.universityId;
                obj.departmentId_dictText = item.departmentId_dictText;
                obj.universityId_dictText = item.universityId_dictText;
                for (var key in arr[i]) {
                  if (key == "参与人数") {
                    obj.peoplenum = arr[i][key];
                  }
                  if (key == "训练日期") {
                    obj.traintime = arr[i][key];
                  }
                  if (key == "参与院系" || key == "参与部门") {
                    obj.traindepartment = arr[i][key];
                  }
                }
                console.log(obj);
                allarr.push(obj);
              }
            } else {
              // break
            }
          });
          console.log(allarr);
          this.tableData = allarr;
        } else if (res.data.code != 500) {
        }
      });
    },
    // 获取单位训练记录
    alluniverrecord() {
      if (!infoAction.getinfo("teacher_info").universityId) {
        return;
      }
      Axios.get(this.url.alluniverrecord, {
        params: {
          universityId: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          var allarr = [];
          console.log(records);
          records.map((item, index) => {
            console.log(item.originalData);
            var arr;
            if (item.step == "1" && JSON.parse(item.originalData).length) {
              console.log(item.originalData);
              var originalData = JSON.parse(item.originalData)[0];
              var obj = {};
              obj.id = item.id;
              obj.departmentId = item.departmentId;
              obj.universityId = item.universityId;
              obj.departmentId_dictText = item.departmentId_dictText;
              obj.universityId_dictText = item.universityId_dictText;
              obj.peoplenum = originalData.参与人数;
              obj.traintime = originalData.训练日期;
              obj.traindepartment = originalData.参与部门 || originalData.参与院系;
              obj.activeCode = item.activeCode;
              allarr.push(obj);
            }
          });
          console.log(allarr);
          this.tableData = allarr;
        } else if (res.data.code != 500) {
        }
      });
    },
    // 获取预约列表
    gettrainlist(pageNo = 1) {
      var that = this;
      Axios.get(this.url.trainlist, {
        params: {
          pageNo: pageNo,
          pageSize: 5,
          universityName: infoAction.getinfo("universityId_dictText", false),
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.result;
          console.log(that.trainlist);
          console.log(result.records);
          that.trainlist = result.records;
          that.pagination.total = result.total;
        }
      });
    },
    // 获取单位信息
    getunivesity() {
      Axios.get(this.url.university, {
        params: {
          id: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          infoAction.setinfo("universityinfo", JSON.stringify(res.data.result));
          this.bookinfo.universityName = res.data.result.universityName;
          this.getdepartment(res.data.result.universityCode);
        }
      });
    },
    // 获取学院列表
    getdepartment(universityCode) {
      Axios.get(this.url.departlist, {
        params: {
          pageNo: 1,
          pageSize: 100,
          universityId: universityCode,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.result;
          this.departlist = result.records;
        }
      });
    },
    // 确认预约
    sureappoint() {
      if (this.traintime) {
        this.bookinfo.orderDate = this.traintime;
      } else {
        this.$message.warning("请选择训练时间");
        return;
      }
      if (!this.bookinfo.linkMan) {
        this.$message.warning("请输入联系人");
        return;
      }
      var iphonereg = new RegExp(/^1[3456789]\d{9}$/);
      if (!iphonereg.test(this.bookinfo.iphone)) {
        console.log(this.bookinfo.iphone);
        this.$message.warning("手机号码格式匹配，请重新输入");
        return;
      }

      Axios.post(this.url.appoint, this.bookinfo).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("预约成功");
          this.gettrainlist();
        }
      });
      this.centerDialogVisible = false;
    },
    // 取消预约框
    closeappoint() {
      this.centerDialogVisible = false;
    },
    // 训练安排查看详情
    seedetails(data) {
      // console.log(data);
      this.$router.push({
        path: "/traindetails",
        query: {
          id: data.id,
          time: data.traintime,
          numofman: data.peoplenum,
          activeCode: data.activeCode,
          departmentId: data.departmentId,
          universityId: data.universityId,
          departmentId_dictText: data.departmentId_dictText,
          universityId_dictText: data.universityId_dictText,
        },
      });
    },
    // 部门改变
    handdepartChange() {},
    // 时间选择方法
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },
    disabledDateTime() {
      return {
        // disabledHours: () => [
        //   0, 1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 19, 20, 21, 22, 23,
        // ],
        // // disabledHours: () => this.range(17,24).splice(17,9),
        // disabledMinutes: () => this.range(),
        // disabledSeconds: () => [],
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    },
    onPageChange(page) {
      console.log(page);
      // this.pagination.pageNo = page;
      this.pagination.current = page;
      this.gettrainlist(page);
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
.moreRecord {
  font-size: 15px;
  color: #999999;
  line-height: 25px;
  margin-left: auto;
  padding-right: 1vw;
  font-weight: normal;
}
}
@media screen and (min-width: 768px) {
.moreRecord {
  font-size: 15px;
  color: #999999;
  padding-right: 1vw;
  line-height: 30px;
  margin-left: auto;
  font-weight: normal;
}
}
@media screen and (max-width: 768px) {
.tablebox >>> .ant-table-thead {
  background: #E0E6F6;
}
.tablebox >>> .ant-table-thead > tr > th {
  padding: 16px 5px !important;
  background: #E0E6F6;
  font-size: 14px;
  color: #333333;
}
.tablebox >>> .ant-table-thead > tr > th> .ant-table-header-column {
  font-weight: bold;
}
.tablebox >>> .ant-table-tbody > tr > td {
  padding: 16px 5px !important;
}
}
@media screen and (min-width: 768px) {
.tablebox >>> .ant-table-thead {
  background: #E0E6F6;
}
.tablebox >>> .ant-table-thead > tr > th {
  padding: 37px 5px !important;
  background: #E0E6F6;
  font-size: 23px;
  font-weight: bold;
  color: #333333;
}
.tablebox >>> .ant-table-tbody > tr > td {
  padding: 16px 5px !important;
  font-size: 19px;
}
}
.cardContainer {
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 768px) {
  .btnBox {
    position: relative;
    /* top: -130px; */
    padding-bottom: 10px;
  }
}
@media screen and (min-width: 768px) {
  .btnBox {
    position: relative;
    /* top: -130px; */
    padding-bottom: 10px;
    padding: 0 2px;
  }
}
element.style {
  text-align: center;
}
.ant-table-thead > tr:first-child > th:first-child {
  border-top-left-radius: 4px;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 16px;
  overflow-wrap: break-word;
}
@media screen and (max-width: 768px) {
.titlePic {
  width: 22px;
  height: auto;
  margin-right: 10px;
  position: relative;
  top: -3px;
}
}
@media screen and (min-width: 768px) {
  .titlePic {
    width: 36px;
    height: auto;
    margin-right: 10px;
    position: relative;
    top: -3px;
}
}
.tit {
  flex-shrink: 0;
}
@media screen and (min-width: 768px) {
  .tit {
    flex-shrink: 0;
    font-size: 31px;
    font-weight: bold;
  }
}
.configBox {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  padding: 1vw;
}
.itemContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
@media screen and (min-width: 768px) {
.configItem {
  width: 28%;
  height: 250px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background: #e9eef9;
  font-size: 23px;
  color: #333333;
  cursor: pointer;
  font-weight: bold;
}
.configImg {
  width: 50px;
  height: 50px;
  margin-top: 50px;
  margin-bottom: 5px;
}
}

@media screen and (max-width: 768px) {
  .configItem {
    width: 28%;
    height: 90px;
    box-sizing: border-box;
    margin-bottom: 10px;
    background: #e9eef9;
  }
  .configItem div {
    color: #333333;
    font-size: 14px;
    font-weight: bold;
  }
  .configImg {
    width: 25px;
    height: 25px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
.reportContainer {
  width: 100%;
  padding: 3vw 1vw;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.reportItem {
  position: relative;
  cursor: pointer;
  margin-right: 30px;
}
.reportImg {
  width: auto;
  height: 240px;
  margin-bottom: 15px;
}
.reportDate {
  position: absolute;
  color: #333333;
  font-size: 19px;
  font-weight: bold;
  top: 30%;
  left: 23%;
}
@media screen and (max-width: 768px) {
  .reportImg {
    width: auto;
    height: 130px;
    margin-bottom: 15px;
  }
  .reportDate {
    position: relative;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    top: -61%;
    left: 1%;
  }
}
@media screen and (min-width: 768px) {
  .leftpadding {
    box-sizing: border-box;
    width: 50%;
    margin: auto;
  }
}
.leftpadding {
  box-sizing: border-box;
  /* padding: 50px 3vw; */
}
.solid {
  height: 20px;
  /* background-color: #f0f2f5; */
}
.crumbs {
  box-sizing: border-box;
  padding: 30px 0 0 0;
  border-bottom: 2px solid #f0f2f5;
}
.flex {
  display: flex;
  padding: 0 14px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) {
  .flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
}
.tableContainer {
  position: relative;
  /* top: -90px; */
  padding: 10px;
}
@media screen and (max-width: 768px) {
.titleText {
  margin-top: 3vh;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
}
@media screen and (min-width: 768px) {
.titleText {
  margin-top: 94px;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 31px;
  display: flex;
  align-items: flex-end;
}
}
@media screen and (min-width: 768px) {
.recordBox {
  margin-top: 30px;
}
}
.title {
  margin-top: 3vh;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
.ant-table-column-title {
  overflow: inherit !important;
}
@media screen and (min-width: 768px) {
  .cardbox {
    padding-bottom: 30px;
    border-bottom: 20px solid #f3f1f1;
    margin-bottom: 41px;
  }
}
@media screen and (max-width: 768px) {
  .cardbox {
    border-bottom: 10px solid #f3f1f1;
  }
}
@media screen and (min-width: 768px) {
  .btnsize {
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    font-size: 23px;
    height: 58px;
    margin: 0 10px;
  }
}
@media screen and (max-width: 768px) {
  .btnsize {
    box-sizing: border-box;
    margin: 0 10px;
    font-size: 12px;
    height: 30px;
    border: none;
  }
}
.sou-btn {
  width: 13px; 
  height: 13px;
  margin-right: 5px;
  margin-top: -2px
}
@media screen and (min-width: 768px) { 
  .sou-btn {
    width: 18px; 
    height: 18px;
    margin-right: 5px
}
}
.bookbtn {
  box-shadow: 1px 4px 13px 0px rgba(25, 50, 100, 0.29);
}
.tablebox {
  box-shadow: 0px 4px 24px 0px rgba(45, 44, 44, 0.17);
  margin-top: 2vh;
  margin-bottom: 3vh;
}
.inputtext {
  text-align: right;
  flex-shrink: 0;
}
.inputs {
  flex-shrink: 1;
}
.inputbar {
  margin-bottom: 3vh;
}
.booksurebtn {
  width: 50%;
}
.icon {
  margin-right: 1vw;
}
/* .departselect::webkit-scrollbar { 
   display: none;
}
.depart::webkit-scrollbar { 
   display: none;
} */
/* @media screen and (max-width: 768px) {

} */
</style>



// WEBPACK FOOTER //
// src/views/homepagetwo/homepagetwo.vue